import React, { createContext, useContext, useEffect } from 'react';

/*
  ByMarke Dashboard — tema CHIARO sempre attivo (stile Task Radar).
  Mantengo l'API del context (theme/toggleTheme/setTheme/isDark) così che i
  componenti che la usano continuino a funzionare senza modifiche logiche.
  toggleTheme/setTheme sono no-op: non c'è una dark mode. isDark è sempre false.
*/

type Theme = 'light';

interface ThemeContextType {
  theme: Theme;
  toggleTheme: () => void;
  setTheme: (theme: Theme) => void;
  isDark: boolean;
}

const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

export const ThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  // Toglie l'eventuale .dark residua (vecchie sessioni) e fissa il chiaro
  useEffect(() => {
    const root = document.documentElement;
    root.classList.remove('dark');
    root.style.colorScheme = 'light';
  }, []);

  const noop = () => { /* chiaro sempre attivo */ };

  return (
    <ThemeContext.Provider
      value={{
        theme: 'light',
        toggleTheme: noop,
        setTheme: noop,
        isDark: false,
      }}
    >
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = (): ThemeContextType => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

export default ThemeContext;
